import React from 'react';
import axios from 'axios';

import { store } from 'STORE';
import api from 'API';
import defaults from 'DEFAULTS';
import { responseError } from 'FIELDS';

let source;

export default async (main_context, query, context) => {
  const { name } = context.state;
  const userType = store.getState().userToken.tokenType;
  const t = context.props.t;

  if (userType === 'aemi') {
    try {
      const response = await axios(api.banking.aemi.aemiCompany.AXIOS('GET'));

      if (main_context._mounted) {
        main_context.setState({
          [name]: {
            ...main_context.state[name],
            keys: prepareData(
              [...response.data.wallets, ...(context.props.item.appendKeys || [])],
              main_context.state.wallet_id.currency_pair,
              main_context.props.currencies
            ),
          },
        });
      }

      if (context._mounted) {
        context.setState({
          fetching: false,
        });
      }
    } catch (error) {
      responseError(error);
    }
  } else {
    let CONFIG;

    CONFIG = api.banking.accounts('', userType).AXIOS('GET', { not_paginated: true });

    if (typeof source !== typeof undefined) {
      source.cancel(t('api.cancel'));
    }

    source = axios.CancelToken.source();
    CONFIG.cancelToken = source.token;

    try {
      const response = await axios(CONFIG);

      if (main_context._mounted) {
        main_context.setState({
          [name]: {
            ...main_context.state[name],
            keys: prepareData(
              [...response.data.data, ...(context.props.item.appendKeys || [])],
              main_context.state.wallet_id.currency_pair,
              main_context.props.currencies
            ),
          },
        });
      }

      if (context._mounted) {
        context.setState({
          fetching: false,
        });
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error('Error fetching data:', error);
      }
    }
  }
};

const prepareData = (items, currency_pair, currencies) => {
  const userType = store.getState().userToken.tokenType;

  items = items.map((item) => {
    const { id, currency, iban, sort_code, account_number, key, balance, custom_account, wallet_type, status, name } =
      item;

    let account;

    if (userType === 'aemi') {
      if (name) {
        account = name;
      } else {
        account = defaults.formatter.accountNumberForDisplay.apply(iban);
        if (custom_account) {
          account = custom_account;
        }

        if (sort_code && account_number) {
          account = `${defaults.formatter.sortCodeForDisplay.apply(
            sort_code
          )} ${defaults.formatter.accountNumberForDisplay.apply(account_number)}`;
        }
      }
    } else {
      account = defaults.formatter.accountNumberForDisplay.apply(iban);
      if (custom_account) {
        account = custom_account;
      }

      if (sort_code && account_number) {
        account = `${defaults.formatter.sortCodeForDisplay.apply(
          sort_code
        )} ${defaults.formatter.accountNumberForDisplay.apply(account_number)}`;
      }
    }

    const pair = currency_pair.split('/');
    const firstCurrency = balance.find((i) => i.currency === pair[0]);
    const secondCurrency = balance.find((i) => i.currency === pair[1]);

    return {
      disabled: status === 'Suspended',
      currency: currency,
      balance: balance,
      sort_code: sort_code,
      account_number: account_number,
      iban: iban,
      title: (
        <div className={'payment-select'}>
          {account}
          {iban && (
            <span className={'no-display-phone'}>
              {firstCurrency?.balance ? defaults.currency.format(firstCurrency?.balance, pair[0], currencies) : '00.00'}{' '}
              {pair[0]} /{' '}
              {secondCurrency?.balance
                ? defaults.currency.format(secondCurrency?.balance, pair[1], currencies)
                : '00.00'}{' '}
              {pair[1]}
            </span>
          )}
        </div>
      ),
      value: id || key,
      wallet_type: wallet_type,
    };
  });

  return items;
};

export { prepareData };
